import { faker } from '@faker-js/faker';
import { delay, http, HttpResponse } from 'msw';

export const handlers = [
  http.get(
    '*/api/js/ap_invoice_transaction_general_inputs/:id/options',
    async ({ request }) => {
      await delay(1000);
      const url = new URL(request.url);
      const page = url.searchParams.get('page');
      const keyword = url.searchParams.get('keyword');
      const visibility = url.searchParams.get('is_visible');
      return new HttpResponse(
        JSON.stringify(
          getGetApInvoiceTransactionGeneralInputsMock(
            page ? parseInt(page) : 1,
            25,
            keyword ?? '',
            visibility === null || visibility === undefined
              ? undefined
              : visibility === 'true'
          )
        ),
        {
          status: 200,
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
    }
  ),
];

const apGeneralInputOptions = Array.from({ length: 90 }, (_, i) => i + 1).map(
  () => ({
    id: faker.number.int({ min: 1, max: 1000000 }),
    label: faker.word.sample(),
    code: faker.word.sample(),
    priority: faker.number.int({ min: 1, max: 100 }),
    is_visible: faker.datatype.boolean(),
    value: faker.word.sample(),
  })
);

const getGetApInvoiceTransactionGeneralInputsMock = (
  page: number,
  per_page: number,
  keyword: string,
  visibility: boolean | undefined
) => {
  const totalItems = apGeneralInputOptions.length;
  const start = (page - 1) * per_page;
  const end = start + per_page;
  const filteredItems = apGeneralInputOptions.filter((item) => {
    const matchesKeyword = keyword
      ? item.label.includes(keyword) || item.code.includes(keyword)
      : true;
    const matchesVisibility =
      visibility !== undefined ? item.is_visible === visibility : true;
    return matchesKeyword && matchesVisibility;
  });
  const paginatedItems = filteredItems
    .sort((a, b) => a.priority - b.priority)
    .slice(start, end);
  return {
    ap_general_input_options: paginatedItems,
    pagination: {
      has_next_page: end < paginatedItems.length,
      has_previous_page: start > 0,
      page,
      per_page,
      total_pages:
        keyword || visibility === true || visibility === false
          ? Math.ceil(paginatedItems.length / per_page)
          : Math.ceil(totalItems / per_page),
      total_records: totalItems,
    },
  };
};
